import { Moon, Sun } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useThemeStore } from '@/store/theme'
import { cn } from '@/lib/utils'

type ThemeToggleVariant = 'portal' | 'regol' | 'menu'

interface ThemeToggleProps {
  variant?: ThemeToggleVariant
  className?: string
}

export function ThemeToggle({ variant = 'portal', className }: ThemeToggleProps) {
  const { t } = useTranslation()
  const { theme, toggleTheme } = useThemeStore()
  const isDark = theme === 'dark'
  const label = isDark ? t('common.lightMode') : t('common.darkMode')
  const icon = isDark ? <Sun className="size-4" aria-hidden="true" /> : <Moon className="size-4" aria-hidden="true" />

  if (variant === 'menu') {
    return (
      <button type="button" onClick={toggleTheme} className={cn('theme-toggle--menu', className)}>
        {icon}
        <span>{label}</span>
      </button>
    )
  }

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={cn(
        'theme-toggle',
        variant === 'regol' ? 'theme-toggle--regol' : 'theme-toggle--portal',
        className,
      )}
      aria-label={label}
      title={label}
    >
      {icon}
    </button>
  )
}
